(function () {
  'use strict';

  // ---------- mobile nav drawer ----------
  function initMobileDrawer() {
    var openBtns = document.querySelectorAll('[data-drawer-open]');
    var drawer = document.querySelector('.mobile-drawer');
    if (!drawer) return;
    var closeBtn = drawer.querySelector('.mobile-drawer__close');
    var scrim = drawer.querySelector('.mobile-drawer__scrim');

    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
  }

  // ---------- PDP gallery: thumbs + prev/next ----------
  function initPdpGallery() {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumbs button'));
    var mainImg = document.getElementById('pdpMain');
    if (!thumbs.length || !mainImg) return;
    var current = 0;

    function show(i) {
      current = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      var btn = thumbs[current];
      btn.classList.add('is-active');
      var img = btn.querySelector('img');
      if (img) {
        mainImg.src = img.getAttribute('data-full') || img.src;
        mainImg.srcset = '';
      }
    }
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); });
    });
    var prevBtn = document.querySelector('.pdp-nav.prev');
    var nextBtn = document.querySelector('.pdp-nav.next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    // expose so the variant picker can jump the gallery to a variant's featured image
    window.__pdpShowImageBySrc = function (src) {
      if (!src) return;
      var idx = thumbs.findIndex(function (b) {
        var img = b.querySelector('img');
        return img && (img.getAttribute('data-full') === src);
      });
      if (idx > -1) show(idx);
    };
  }

  // ---------- collection page: "All Filters" panel toggle ----------
  function initFilterPanel() {
    var toggle = document.getElementById('filterToggle');
    var panel = document.getElementById('filterPanel');
    var done = document.getElementById('doneFilters');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () { panel.classList.toggle('open'); });
    if (done) done.addEventListener('click', function () { panel.classList.remove('open'); });
  }

  // ---------- collection page: sort select navigates with ?sort_by= ----------
  function initSortSelect() {
    var sel = document.getElementById('sortSelect');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  // ---------- PDP variant picker ----------
  function initVariantPicker() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var dataEl = document.getElementById('product-variants-json');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var optionCount = variants.length ? variants[0].options.length : 0;
    var idSelect = root.querySelector('#product-select');
    var priceEl = root.querySelector('[data-variant-price]');
    var comparePriceEl = root.querySelector('[data-variant-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var availabilityEl = root.querySelector('[data-availability]');
    var selected = {};

    root.querySelectorAll('.swatch[data-option-index]').forEach(function (el) {
      if (el.classList.contains('is-active')) selected[el.dataset.optionIndex] = el.dataset.value;
    });
    root.querySelectorAll('.size-pill[data-option-index]').forEach(function (el) {
      if (el.classList.contains('is-active')) selected[el.dataset.optionIndex] = el.dataset.value;
    });

    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (selected[i] !== undefined && v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function refreshSizeAvailability() {
      root.querySelectorAll('.size-pill[data-option-index]').forEach(function (pill) {
        var idx = pill.dataset.optionIndex, val = pill.dataset.value;
        var testSel = Object.assign({}, selected);
        testSel[idx] = val;
        var match = variants.find(function (v) {
          for (var i = 0; i < optionCount; i++) {
            if (testSel[i] !== undefined && v.options[i] !== testSel[i]) return false;
          }
          return true;
        });
        pill.classList.toggle('is-unavailable', !!match && !match.available);
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idSelect) idSelect.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePriceEl.textContent = formatMoney(v.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (addBtn.dataset.addLabel || 'Add to Bag') + ' — ' + formatMoney(v.price)
          : (addBtn.dataset.soldLabel || 'Sold Out');
      }
      if (availabilityEl) {
        availabilityEl.textContent = v.available ? '' : (availabilityEl.dataset.soldMessage || '');
      }
      if (v.featured_image) window.__pdpShowImageBySrc && window.__pdpShowImageBySrc(v.featured_image.src);
      refreshSizeAvailability();
    }

    root.querySelectorAll('[data-option-index]').forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = el.dataset.optionIndex;
        root.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (sib) {
          sib.classList.remove('is-active');
        });
        el.classList.add('is-active');
        selected[idx] = el.dataset.value;
        update();
      });
    });

    refreshSizeAvailability();
  }

  // ---------- accordion: native <details>, no JS needed ----------

  // ---------- quick add-to-cart (product cards) ----------
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-quick-add');
      if (!variantId) return;
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var badge = document.querySelector('.cart-count');
          if (badge) {
            badge.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            var bag = document.querySelector('.navicons a[aria-label="Bag"]');
            if (bag) {
              var span = document.createElement('span');
              span.className = 'cart-count';
              span.textContent = cart.item_count;
              bag.appendChild(span);
            }
          }
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          btn.textContent = originalLabel;
          btn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
    initPdpGallery();
    initFilterPanel();
    initSortSelect();
    initVariantPicker();
    initQuickAdd();
  });
})();
